"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfMarkNotificationReadDataDto = instanceOfMarkNotificationReadDataDto;
exports.MarkNotificationReadDataDtoFromJSON = MarkNotificationReadDataDtoFromJSON;
exports.MarkNotificationReadDataDtoFromJSONTyped = MarkNotificationReadDataDtoFromJSONTyped;
exports.MarkNotificationReadDataDtoToJSON = MarkNotificationReadDataDtoToJSON;
exports.MarkNotificationReadDataDtoToJSONTyped = MarkNotificationReadDataDtoToJSONTyped;
/**
 * Check if a given object implements the MarkNotificationReadDataDto interface.
 */
function instanceOfMarkNotificationReadDataDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('is_read' in value) || value['is_read'] === undefined)
        return false;
    return true;
}
function MarkNotificationReadDataDtoFromJSON(json) {
    return MarkNotificationReadDataDtoFromJSONTyped(json, false);
}
function MarkNotificationReadDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'is_read': json['is_read'],
    };
}
function MarkNotificationReadDataDtoToJSON(json) {
    return MarkNotificationReadDataDtoToJSONTyped(json, false);
}
function MarkNotificationReadDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'is_read': value['is_read'],
    };
}
